<script>
import Layout from '@layouts/primary'
import {
  collectionMethods,
  clientMethods,
  serviceMethods,
  runsheetMethods,
} from '@state/helpers'
import { rrulestr } from 'rrule'
import store from '@state/store'
// import draggable from 'vuedraggable'
import parseTimeMomentJS from '../../utils/format-hour'
import mapboxgl from 'mapbox-gl'
import polyline from '@mapbox/polyline'

export default {
  $_veeValidate: {
    validator: 'new',
  },
  page: {
    title: 'ViewRunSheet',
    meta: [{ name: 'description', content: 'ViewRunSheet' }],
  },
  components: { Layout /* draggable */ },
  data() {
    return {
      totalCentimeters: 0,
      pageEnd: 38,
      pageBreakIndexes: [],
      pageBreakStatus: false,
      isActive: null,
      map: '',
      displayMap: true,
      routeSelected: false,
      collection: [],
      clients: [],
      clientsData: [],
      services: [],
      runsheet: null,
      currentService: [],
      currentServiceBins: [],
      binsData: [],
      sites: [],
      binsToCollect: [],
      currentClientId: '',
      newCollection: {
        client: null,
        driver_id: null,
        service_id: null,
        service_title: null,
        expected_collection_time: null,
        created_by: null,
        collection_date: null,
        collection_time: null,
        order: null,
        lat: null,
        lon: null,
        completed: false, // Default value
        processed: false, // Default value
        runSheetId: null,
        site: {},
      },
      dateDialog: false,
      addCollection: false,
      removeCollection: false,
      removeCurrentCollection: false,
      removeAll: false,
      dictionary: {
        attributes: {
          email: 'E-mail Address',
          // custom attributes
        },
        custom: {
          name: {
            required: () => 'Name can not be empty',
            max: 'The name field may not be greater than 10 characters',
            // custom messages
          },
          select: {
            required: 'Select field is required',
          },
        },
      },
      collectionId: '',
    }
  },
  mounted() {
    let moment = require('moment')
    this.$validator.localize('en', this.dictionary)
    this.newCollection.runSheetId = this.$router.history.current.params.id
    let runsheets = this.$store.state.runsheets.runsheetsUpcoming
    let currentRunsheet = runsheets.find(
      runsheet => runsheet.id === this.newCollection.runSheetId
    )
    this.runsheet = currentRunsheet
    let runsheetCollections = currentRunsheet.collections

    let collections = runsheetCollections
    this.collection = collections
    // Create a copy of the object to update it
    let formattedObj = this.collection

    for (let i in formattedObj) {
      // console.log(formattedObj[i])
      formattedObj[i].collection_date_formatted = moment(
        formattedObj[i].collection_date
      )
        .tz('Australia/Sydney')
        .format('DD/MM/YYYY')
      formattedObj[i].expected_collection_time_formatted = parseTimeMomentJS(
        formattedObj[i].expected_collection_time
      )

      // Define bins to display
      if(formattedObj[i].binsToCollect && formattedObj[i].binsToCollect.length > 0){
        formattedObj[i].binsToDisplay = formattedObj[i].binsToCollect
      } else {
        formattedObj[i].binsToDisplay = formattedObj[i].service.service_bins
      }
    }
    // Get runsheet date of the first element
    if(formattedObj.length > 0 && formattedObj[0].collection_date){
      this.newCollection.collection_date = formattedObj[0].collection_date
    }

    this.collection = formattedObj

    if(this.collection.length > 6){
      this.pageBreakStatus = true
    }

    this.getClients().then(response => {
      let obj = this.$store.state.clients.objects
      for (let v in obj) {
        this.clients.push(obj[v])
      }
      this.clientsData = this.clients.map(index => {
        return { client_id: index.id, client_name: index.client_name }
      })

    })
    let center = [151.2099, -33.865143]
    if (currentRunsheet.route_steps !== 'GENERATED BY ADMIN') {
      let runsteps = JSON.parse(currentRunsheet.route_steps)
      let coords = polyline.decode(currentRunsheet.geometry)

      coords.map(coord => {
        let temp = coord[0]
        coord[0] = coord[1]
        coord[1] = temp
      })
      center = this.averageGeolocation(coords)

      mapboxgl.accessToken =
        'pk.eyJ1Ijoiam9hbm5lbWFuY3VzbyIsImEiOiJjanJhNTRjcWowb200NDlwYzd3amMzNzY5In0.PXQlRcMT7zOb2YklVWZxng'
      let map = ''
      map = new mapboxgl.Map({
        container: 'map',
        style: 'mapbox://styles/joannemancuso/cjrb7u1k31jcg2slwfrymbg2p',
        center: center,
        zoom: 10,
      })

      if (currentRunsheet.collections.length > 0){
        map.on('load', function() {
          map.addLayer({
            id: 'route',
            type: 'line',
            source: {
              type: 'geojson',
              data: {
                type: 'Feature',
                properties: {},
                geometry: {
                  type: 'LineString',
                  coordinates: coords,
                },
              },
            },
            layout: {
              'line-join': 'round',
              'line-cap': 'round',
            },
            paint: {
              'line-color': '#888',
              'line-width': 4,
            },
          })
        })
      }

      runsteps.map(step => {
        if (step.type === 'job') {
          let currentCollection = runsheetCollections.find(
            collection => parseInt(collection.id) === parseInt(step.job)
          )

          let el = document.createElement('div')
          el.className = 'client-marker'

          if (currentCollection){
            // make a marker for each feature and add to the map
            new mapboxgl.Marker(el)
              .setLngLat(step.location)
              .setPopup(
                new mapboxgl.Popup({ offset: 25 }) // add popups
                  .setHTML(
                    (currentCollection.client && currentCollection.client.client_name) ? '<h4>' + currentCollection.client.client_name + '</h4>' : ''
                  )
              )
              .addTo(map)
          }
        }
        if (step.type === 'start') {
          let el = document.createElement('div')
          el.className = 'depot-marker'

          // make a marker for each feature and add to the map
          new mapboxgl.Marker(el)
            .setLngLat(step.location)
            .setPopup(
              new mapboxgl.Popup({ offset: 25 }) // add popups
                .setHTML('<h4>' + 'Depot' + '</h4>')
            )
            .addTo(map)
        }
      })
      this.map = map
    }


  },
  updated () {
    // Calc the heights of the collectionContainer s
    const pixelToCentimeter = 0.0264583333;
    const totalCentimeters = this.pageEnd
    let divs = document.querySelectorAll('.collectionContainer')
    let pageBreakIndexes = []
    // Add up the accumulative height and flag which divs should also break a page for printing
    let accumHeight = 0
    for (let i = 0; i < divs.length; i++) {
      let shouldBreak = false
      // convert to cms based on pixels
      let currentHeight = divs[i].clientHeight * pixelToCentimeter
      accumHeight += currentHeight
      // console.log(i, currentHeight, Math.floor(accumHeight))
      if (Math.floor(accumHeight) >= totalCentimeters) {
        shouldBreak = true
        accumHeight = 3 // starts new page with margin height
        // console.log('Break div', i)
      }
      pageBreakIndexes.push(shouldBreak)
    }
    if (this.pageBreakIndexes.length !== pageBreakIndexes.length) {
      this.$nextTick(() => {
        this.pageBreakIndexes = pageBreakIndexes
      })
    }
  },
  methods: {
    ...collectionMethods,
    ...clientMethods,
    ...serviceMethods,
    ...runsheetMethods,
    async highlightRoute(id) {
      let runsheets = this.$store.state.runsheets.runsheetsUpcoming
      let currentRunsheet = runsheets.find(
        runsheet => runsheet.id === this.newCollection.runSheetId
      )
      let runsteps = JSON.parse(currentRunsheet.route_steps)
      let selectedStep = runsteps.find(step => step.job === parseInt(id))
      let previousIndexStep = runsteps.indexOf(selectedStep) - 1
      let previousStep = runsteps[previousIndexStep]
      let polylineValue = await this.getPolyline({
        latOne: previousStep.location[1],
        latTwo: selectedStep.location[1],
        lonOne: previousStep.location[0],
        lonTwo: selectedStep.location[0],
      })
      let segment = polyline.decode(polylineValue.data.getPolyline)
      segment.map(coord => {
        let temp = coord[0]
        coord[0] = coord[1]
        coord[1] = temp
      })

      try {
        if (this.routeSelected === true) {
          this.map.removeLayer('route2')
          this.map.removeSource('route2')
        }
      } catch (err) {}

      this.map.addLayer({
        id: 'route2',
        type: 'line',
        source: {
          type: 'geojson',
          data: {
            type: 'Feature',
            properties: {},
            geometry: {
              type: 'LineString',
              coordinates: segment,
            },
          },
        },
        layout: {
          'line-join': 'round',
          'line-cap': 'round',
        },
        paint: {
          'line-color': '#499BF8',
          'line-width': 6,
        },
      })
      this.routeSelected = true
      this.isActive = id
    },
    averageGeolocation(coords) {
      if (coords.length === 1) {
        return coords[0]
      }

      let x = 0.0
      let y = 0.0

      coords.map(coord => {
        x += coord[0]
        y += coord[1]
      })

      return [x / coords.length, y / coords.length]
    },
    async createNewCollection(collection) {
      await this.$validator.validateAll().then(response => {
        if (response) {
          let userId = store.getters['auth/getUserId']

          let moments = require('moment')

          let serviceId = this.newCollection.service_id
          let expectedCollectionTime = this.newCollection
            .expected_collection_time
          let createdBy = userId
          let collectionTime = this.newCollection.expected_collection_time
          let order = this.newCollection.order
          let completed = this.newCollection.completed
          let processed = this.newCollection.processed
          let runsheetId = this.newCollection.runSheetId
          let siteSelected = this.newCollection.siteSelected

          let collectionDate = moments(this.newCollection.collection_date).parseZone().toISOString()
          // console.log(collectionDate)

          // Get bins IDs from the items selected
          let binsIds = []
          // console.log(this.binsToCollect)
          for (let i in this.binsToCollect) {
            if(this.binsToCollect[i])
              binsIds.push(parseInt(this.binsToCollect[i]))
          }

          this.createCollection({
            service_id: parseInt(serviceId),
            expected_collection_time: expectedCollectionTime,
            created_by: createdBy,
            collection_date: collectionDate,
            collection_time: collectionTime,
            order: order,
            completed: completed,
            processed: processed,
            runsheetId: runsheetId,
            bins: binsIds,
            siteId: parseInt(siteSelected),
          }).then(d => {
            // NOTIFY DRIVER WITH COLLECTION
            const _channel = 'collection'

            let _message = {
              driverMessageTitle: 'Attention - Collection Added by Admin',
              collectionObj: collection,
              runsheet: runsheetId,
              collectionId: d.data.createCollection.id,
            }

            this.notifyDriverWithCollectionData({
              channel: _channel,
              message: JSON.stringify(_message),
            }).then(res => {
              // console.log(res)

              this.$router.push('/admin/run-sheets/')
              location.reload()
            })
          })
        }
      })
    },
    clear() {
      this.newCollection = {}
      this.$validator.reset()
      this.addCollection = false
    },
    changeRoute(r) {
      this.$router.push(r)
    },
    rulify(s) {
      if (s) {
        return rrulestr(s)
          .toText()
          .toUpperCase()
      } else return 'No Schedule'
    },
    getClientID(client) {
      let cid = null
      for (let i in this.clientsData) {
        if (client === this.clientsData[i].client_name) {
          cid = this.clientsData[i].client_id
        }
      }
      return cid
    },
    async onClientChange(client) {
      // Clean current data before populate again
      this.services = []
      this.binsData = []
      this.currentService = []
      this.newCollection.site = {}
      let cid = this.getClientID(client)
      this.currentClientId = cid
      await this.getServiceByClientId({
        id: cid
      }).then(response => {
        // console.log(response)
        this.services = response
      })
    },
    setCurrentService(service) {
      // console.log(service)
      this.currentService = []
      this.binsData = []
      this.sites = []
      for (let i in this.services) {
        if (this.services[i].client_id.id === this.currentClientId) {
          if (service === this.services[i].service_title) {
            // console.log(this.services[i])
            this.sites.push(this.services[i].site)
            this.currentServiceBins = this.services[i].service_bins
            // this.currentService = this.services[i].site
            // this.newCollection.site = this.currentService
            this.newCollection.service_id = this.services[i].id
            this.newCollection.service_title = this.services[i].service_title
          }
        }
      }
      // Get bins info to display on the PopUp
      let binObj = {}
      let allBins = []
      for (let i in this.currentServiceBins) {
        allBins.push(this.currentServiceBins[i].bin)
      }

      for (let i in allBins) {
        binObj = {
          index: '',
          description: '',
          id: '',
          name: '',
        }

        let index = parseInt(i)
        binObj.index = index += 1
        binObj.description = allBins[i].description
        binObj.id = allBins[i].id
        binObj.name = allBins[i].name

        this.binsData.push(binObj)
      }
    },
    onServiceChange(service) {
      this.setCurrentService(service)
    },
    onBinSelected(bins) {

      this.binsToCollect = []

      // Get only the bin obj based on the index selected
      for(let i in bins){
        for(let bin in this.binsData){
          if(bins[i] === this.binsData[bin].index){
            this.binsToCollect.push(this.currentServiceBins[bin].id)
          }
        }
      }
    },
    onSiteSelected(site){
      // Get site obj based on the ID Selected
      for(let i in this.sites){
        if(parseInt(this.sites[i].id) === parseInt(site)){
          this.newCollection.site = this.sites[i];
          return
        }
      }
    },
    deleteCollectionModal(id) {
      this.removeCollection = !this.removeCollection
      this.collectionId = id
      // // console.log(id)
    },
    removeCollectionModal(id){
      this.removeCurrentCollection = !this.removeCurrentCollection
      this.collectionId = id
    },
    performDelete() {
      this.deleteCollection({ id: parseInt(this.collectionId) }).then(res => {
        this.$router.push('/admin/run-sheets/')
        location.reload()
      })
    },
    print() {
      // console.log(window)
      window.print()
    },
    performRemoveAll() {
      let arrayOfCollectionIds = []

      for (let i in this.collection) {
        arrayOfCollectionIds.push(parseInt(this.collection[i].id))
      }

      // Remove RunsheetId from all collections
      this.moveCollectionsToRunSheet({
        collectionIds: arrayOfCollectionIds,
        runsheetId: null,
      }).then(d => {
        this.changeRoute('/admin/run-sheets')
        location.reload()
      })
    },
    performRemoveCollection() {
      let arrayOfCollectionIds = []
      arrayOfCollectionIds.push(parseInt(this.collectionId))

      // Remove RunsheetId from all collections
      this.moveCollectionsToRunSheet({
        collectionIds: arrayOfCollectionIds,
        runsheetId: null,
      }).then(d => {
        this.changeRoute('/admin/run-sheets')
        location.reload()
      })
    },
    onDateChange(date) {
      this.dateDialog = false
    },
  },
}
</script>

<template>
  <Layout>
    <VContainer
      grid-list-md
      class="runsheetWrapper"
    >
      <div class>
        <h2 :class="$style.routeHeader">
          View Runsheet - Collections
        </h2>
      </div>
      <!-- <div
        class="buttonsContainer"
      > -->
      <VLayout 
        justify-end 
        wrap 
        class="buttonsContainer"
      >
        <VBtn
          slot="activator"
          :class="$style.addButton"
          color="green"
          @click="removeAll = !removeAll"
        >
          <span class="hidden-sm-and-up">
            REMOVE ALL COLLECTIONS
          </span>
          <span class="hidden-xs-only">
            REMOVE COLLECTIONS FROM THIS RUNSHEET
          </span>
        </VBtn>
        <VBtn

          slot="activator"
          :class="$style.addButton"
          color="blue"
          @click="addCollection = !addCollection"
        >+ ADD COLLECTION</VBtn>
        <VBtn
          slot="activator"
          class="hidden-sm-and-down"
          :class="$style.addButton"
          color="blue"
          outline
          @click="print"
        >
          <i class="fas fa-print" />PRINT
        </VBtn>
      </VLayout>
      <!-- </div> -->

      <!-- <br>
      <br> -->
      <br>
      <br>

      <VLayout 
        v-for="(element, index) in collection" 
        :key="index"
        wrap
      >
        <div 
          v-if="pageBreakIndexes[index]" 
          :class="{ pagebreak: !!pageBreakIndexes[index] }"
        >
          &nbsp;
        </div>
        <VFlex 
          :id="element.id"
          :key="element.id"
          lg12
          class="collectionContainer"
          :class="{ isActive: isActive === element.id }"
          @click="highlightRoute(element.id)"
        >
          <VLayout
            row
            wrap
          >
            <VFlex
              xs6
              sm4
              md4
              lg4
              class="clientInfo"
            >
              <h5>
                <i class="fas fa-user" />
                Client - {{ element.client.client_name }}
              </h5>
              <h5 v-if="element.site">
                Trading - {{ element.site.trading_name }}
              </h5>
              <p v-if="element.site">
                <i class="fas fa-map-marker" />
                {{ element.site.address }} , {{ element.site.suburb }} , {{ element.site.postcode }}
              </p>

            </VFlex>
            <VFlex
              xs6
              sm3
              md3
              lg3
              class="clientInfo"
            >
              <h5 v-if="element.site">
                <i class="fas fa-mobile-alt" />
                {{ element.site.mobile }} - {{ element.site.phone }}
              </h5>
              <p v-if="element.site">
                Contact - {{ element.site.contact_name }}
              </p>
              <p v-if="element.collection_date_formatted ">
                <i class="fas fa-calendar-alt" />
                {{ element.collection_date_formatted }}
              </p>
            </VFlex>
            <VFlex
              xs6
              sm3
              md3
              lg3
              class="binsInfo"
            >
              <p
                v-if="element.binsToDisplay"
              >Bins to be collected = {{ element.binsToDisplay.length }}</p>
              <ul
                v-for="item in element.binsToDisplay"
                :key="item.id"
              >
                <li v-if="item.bin.name">
                  {{ item.bin.name }}
                </li>
              </ul>
              <br>
            </VFlex>
            <VFlex
              xs6
              sm2
              md2
              lg2
              text-xs-center
              class="buttonsContainer"
            >
              <VBtn
                slot="activator"
                color="green"
                :disabled="element.completed"
                @click="removeCollectionModal(element.id)"
              >REMOVE</VBtn>
              <VBtn
                slot="activator"
                color="orange"
                :disabled="element.completed"
                @click="deleteCollectionModal(element.id)"
              >DELETE</VBtn>
            </VFlex>
          </VLayout>
        </VFlex>
      </VLayout>
    </VContainer>

    <VLayout
      row
      justify-center
    >
      <VDialog
        v-model="removeCollection"
        persistent
        max-width="500px"
        scrollable
      >
        <VCard>
          <VCardText>
            <VContainer grid-list-md>
              <h2>Are you sure you want to delete collection {{ collectionId }}?</h2>
              <VLayout wrap>
                <VFlex
                  xs12
                  sm6
                  md6
                >
                  <VBtn
                    color="blue"
                    block
                    outline
                    @click.native="removeCollection = !removeCollection"
                  >Close</VBtn>
                </VFlex>
                <VFlex
                  xs12
                  sm6
                  md6
                >
                  <VBtn
                    color="orange"
                    block
                    @click.native="performDelete()"
                  >
                    DELETE
                  </VBtn>
                </VFlex>
              </VLayout>
            </VContainer>
          </VCardText>
        </VCard>
      </VDialog>
    </VLayout>

    <VLayout
      row
      justify-center
    >
      <VDialog
        v-model="removeAll"
        persistent
        max-width="500px"
        scrollable
      >
        <VCard>
          <VCardText>
            <VContainer grid-list-md>
              <h2>Are you sure you want to remove all collections from this runsheet?</h2>
              <VLayout wrap>
                <VFlex
                  xs12
                  sm6
                  md6
                >
                  <VBtn
                    color="blue"
                    block
                    outline
                    @click.native="removeAll = !removeAll"
                  >
                    Close
                  </VBtn>
                </VFlex>
                <VFlex
                  xs12
                  sm6
                  md6
                >
                  <VBtn
                    color="green"
                    block
                    @click.native="performRemoveAll()"
                  >
                    CONFIRM
                  </VBtn>
                </VFlex>
              </VLayout>
            </VContainer>
          </VCardText>
        </VCard>
      </VDialog>
    </VLayout>

    <VLayout
      row
      justify-center
    >
      <VDialog
        v-model="removeCurrentCollection"
        persistent
        max-width="500px"
        scrollable
      >
        <VCard>
          <VCardText>
            <VContainer grid-list-md>
              <h2>Are you sure you want to remove collection {{ collectionId }} from this runsheet?</h2>
              <VLayout wrap>
                <VFlex
                  xs12
                  sm6
                  md6
                >
                  <VBtn
                    color="blue"
                    block
                    outline
                    @click.native="removeCurrentCollection = !removeCurrentCollection"
                  >
                    Close
                  </VBtn>
                </VFlex>
                <VFlex
                  xs12
                  sm6
                  md6
                >
                  <VBtn
                    color="green"
                    block
                    @click.native="performRemoveCollection()"
                  >
                    CONFIRM
                  </VBtn>
                </VFlex>
              </VLayout>
            </VContainer>
          </VCardText>
        </VCard>
      </VDialog>
    </VLayout>

    <VLayout
      row
      justify-center
    >
      <VDialog
        v-model="addCollection"
        persistent
        max-width="500px"
        scrollable
      >
        <VCard>
          <VCardText>
            <VContainer grid-list-md>
              <h2>New Collection</h2>
              <VLayout wrap>
                <VFlex xs12>
                  <VAutocomplete
                    v-model="newCollection.client"
                    v-validate="'required'"
                    :error-messages="errors.collect('client_name')"
                    data-vv-name="client_name"
                    :items="clients"
                    item-text="client_name"
                    label="Client"
                    required
                    :menu-props="{ absolute: true }"
                    attach
                    @change="onClientChange(newCollection.client)"
                  />
                </VFlex>

                <VFlex xs12>
                  <VAutocomplete
                    v-model="newCollection.service_title"
                    v-validate="'required'"
                    :error-messages="errors.collect('service')"
                    data-vv-name="service"
                    :items="services"
                    item-text="service_title"
                    label="Service"
                    required
                    :menu-props="{ absolute: true }"
                    attach
                    @change="onServiceChange(newCollection.service_title)"
                  />
                </VFlex>

                <VFlex xs12>
                  <VAutocomplete
                    v-model="newCollection.binsSelected"
                    v-validate="'required'"
                    :error-messages="errors.collect('bins')"
                    data-vv-name="bins"
                    :items="binsData"
                    item-text="description"
                    item-value="index"
                    label="Bins"
                    required
                    :menu-props="{ absolute: true }"
                    attach
                    multiple
                    chips
                    @change="onBinSelected(newCollection.binsSelected)"
                  />
                </VFlex>

                <VFlex xs12>
                  <VAutocomplete
                    v-model="newCollection.siteSelected"
                    v-validate="'required'"
                    :error-messages="errors.collect('site')"
                    data-vv-name="site"
                    :items="sites"
                    item-text="address"
                    item-value="id"
                    label="Site"
                    required
                    :menu-props="{ absolute: true }"
                    attach
                    @change="onSiteSelected(newCollection.siteSelected)"
                  />
                </VFlex>

                <VFlex xs12>
                  <VTextField
                    v-model="newCollection.site.trading_name"
                    label="Trading Name"
                    required
                    readonly
                  />
                </VFlex>

                <VFlex xs12>
                  <VTextField
                    v-model="newCollection.site.address"
                    label="Address"
                    required
                    readonly
                  />
                </VFlex>

                <VLayout wrap>
                  <VFlex xs3>
                    <VTextField
                      v-model="newCollection.site.postcode"
                      label="Post Code"
                      required
                      readonly
                    />
                  </VFlex>
                  <VFlex xs9>
                    <VTextField
                      v-model="newCollection.site.suburb"
                      label="Suburb"
                      required
                      readonly
                    />
                  </VFlex>
                </VLayout>

                <VLayout wrap>
                  <VFlex xs6>
                    <VTextField
                      v-model="newCollection.site.mobile"
                      label="Mobile"
                      required
                      readonly
                    />
                  </VFlex>
                  <VFlex xs6>
                    <VTextField
                      v-model="newCollection.site.phone"
                      label="Phone"
                      required
                      readonly
                    />
                  </VFlex>
                </VLayout>

                <VLayout wrap>
                  <VFlex xs6>
                    <VDialog 
                      v-model="dateDialog" 
                      persistent 
                      width="290px"
                    >
                      <VTextField
                        slot="activator"
                        v-model="newCollection.collection_date"
                        v-validate="'required'"
                        :error-messages="errors.collect('date')"
                        data-vv-name="date"
                        label="Date"
                        append-icon="event"
                        readonly
                      />
                      <VDatePicker
                        v-model="newCollection.collection_date"
                        header-color="#00baff"
                        color="#00baff"
                        scrollable
                        @input="onDateChange(newCollection.collection_date)"
                      />
                    </VDialog>
                  </VFlex>
                  <VFlex xs6>
                    <VTextField
                      v-model="newCollection.expected_collection_time"
                      type="time"
                      label="Access Time"
                      required
                    />
                  </VFlex>
                </VLayout>
                <VFlex xs12>
                  <VTextField
                    slot="activator"
                    v-model="newCollection.runSheetId"
                    label="Run Sheet"
                    readonly
                  />
                </VFlex>

                <VFlex
                  xs12
                  sm6
                  md5
                  lg5
                >
                  <VBtn
                    color="blue"
                    block
                    outline
                    @click.native="addCollection = false"
                  >
                    Close
                  </VBtn>
                </VFlex>
                <VFlex
                  xs12
                  sm6
                  md5
                  offset-md2
                  offset-lg2
                  lg5
                >
                  <VBtn
                    color="blue"
                    block
                    @click.native="createNewCollection(newCollection)"
                  >
                    Save
                  </VBtn>
                </VFlex>
              </VLayout>
            </VContainer>
          </VCardText>
        </VCard>
      </VDialog>
    </VLayout>

    <VContainer
      v-if="displayMap"
      class="mapContainer"
    >
      <h2 :class="$style.routeHeader">
        Map
      </h2>

      <VLayout
        row
        wrap
      >
        <VFlex
          xs12
          sm12
          md12
          lg12
        >
          <VCard :class="$style.mapCard">
            <VContainer>
              <VLayout
                row
                wrap
              >
                <VFlex
                  xs12
                  sm12
                  md12
                  lg12
                >
                  <div id="map" />
                </VFlex>
              </VLayout>
            </VContainer>
          </VCard>
        </VFlex>
      </VLayout>
    </VContainer>
  </Layout>
</template>

<style lang="scss" module>
@import '@design';

.mapCard {
   height: 75vh !important;
 }

h5 {
  margin-bottom: 16px;
  font-weight: 600;
}

i {
  margin-right: 5px;
}
.routeHeader {
  display: inline-block;
}

.addButton {
  display: inline-block;
  float: right;
}

.buttonDelete {
  position: absolute;
  right: 0;
  padding-bottom: 1em;
  margin-right: 3.5em;
  align-self: center;
}

</style>
